import { FieldStatusEnum } from 'components/form'
import { LocalAtendimento, OrientacoesQuery, TipoAtendimentoEnum } from 'graphql/types.generated'
import { isUndefinedOrNull } from 'util/checks'
import { LotacaoFolhaRosto } from 'view/atendimentos/detail/folha-rosto/model'
import { LotacaoAtendimento } from 'view/atendimentos/types/AtendimentoProfissionalModel'

import { OrientacaoFormModel, OrientacaoRowModel } from './model-orientacoes'

export function convertRowModelToFormModel(row: OrientacaoRowModel): OrientacaoFormModel {
  if (isUndefinedOrNull(row)) {
    return row
  }

  return {
    _id: row?._id,
    editingId: row?.editingId,
    descricao: row?.descricao,
  }
}

export const convertOrientacaoDatabaseToRowModel = (
  orientacao: OrientacoesQuery['orientacoes'][0]
): OrientacaoRowModel | null =>
  orientacao
    ? {
        _id: orientacao.id,
        status: FieldStatusEnum.NAO_MODIFICADO,
        ...orientacao,
      }
    : null

export function convertFormModelToRowModel(
  orientacaoCache: OrientacaoFormModel,
  status: FieldStatusEnum,
  dataReferencia: Instant,
  atendimentoProfissionalId: ID,
  atendimentoId: ID,
  lotacao: LotacaoAtendimento | LotacaoFolhaRosto,
  tipoAtendimento?: TipoAtendimentoEnum,
  localAtendimento?: LocalAtendimento
): OrientacaoRowModel | null {
  return orientacaoCache
    ? {
        _id: orientacaoCache._id,
        status,
        editingId: orientacaoCache.editingId,
        descricao: orientacaoCache.descricao,
        atendimentoProfissional: {
          id: atendimentoProfissionalId,
          iniciadoEm: dataReferencia,
          lotacao,
          tipoAtendimento,
          atendimento: {
            id: atendimentoId,
            localAtendimento: localAtendimento,
          },
        },
      }
    : null
}
